var _rect, _polyline, _polyline2, _polyline3, _polyline4, _path, _path2, _path3, _path4, _path5, _path6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHalfdonutThumb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1000,
    height: 600,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    baseProfile: "full",
    viewBox: "0 0 1000 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1000,
    height: 600,
    x: 0,
    y: 0,
    id: 0,
    fill: "#FFFFFF"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "238.1 336.5 224.2 330.8 209.2 330.8",
    fill: "none",
    stroke: "#009bd7"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    points: "391.5 183.1 385.8 169.2 370.8 169.2",
    fill: "none",
    stroke: "#f0a82d"
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    points: "608.5 183.1 614.2 169.2 629.2 169.2",
    fill: "none",
    stroke: "#e95000"
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    points: "761.9 336.5 775.8 330.8 790.8 330.8",
    fill: "none",
    stroke: "#af46a8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M216.5 445A283.5 283.5 0 0 1 299.5352 244.5352L428.4054 373.4054A101.25 101.25 0 0 0 398.75 445Z",
    fill: "#009bd7",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M299.5352 244.5352A283.5 283.5 0 0 1 500 161.5L500 343.75A101.25 101.25 0 0 0 428.4054 373.4054Z",
    fill: "#f0a82d",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M500 161.5A283.5 283.5 0 0 1 700.4648 244.5352L571.5946 373.4054A101.25 101.25 0 0 0 500 343.75Z",
    fill: "#e95000",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M700.4648 244.5352A283.5 283.5 0 0 1 783.5 445L601.25 445A101.25 101.25 0 0 0 571.5946 373.4054Z",
    fill: "rgb(175,70,168)",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M783.5 445A283.5 283.5 0 1 1 216.5 445L398.75 445A101.25 101.25 0 0 0 601.25 445Z",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M783.5 445A283.5 283.5 0 1 1 216.5 445L398.75 445A101.25 101.25 0 0 0 601.25 445Z",
    fill: "url(#zr1-p0)",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "end",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(204.222 330.769)",
    fill: "#333",
    stroke: "rgb(255,255,255)",
    strokeWidth: 2,
    paintOrder: "stroke",
    strokeMiterlimit: 2
  }, "Premiere_Year"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "end",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(365.769 169.222)",
    fill: "#333",
    stroke: "rgb(255,255,255)",
    strokeWidth: 2,
    paintOrder: "stroke",
    strokeMiterlimit: 2
  }, "Seasons"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "start",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(634.231 169.222)",
    fill: "#333",
    stroke: "rgb(255,255,255)",
    strokeWidth: 2,
    paintOrder: "stroke",
    strokeMiterlimit: 2
  }, "Episodes"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "start",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(795.778 330.769)",
    fill: "#333",
    stroke: "rgb(255,255,255)",
    strokeWidth: 2,
    paintOrder: "stroke",
    strokeMiterlimit: 2
  }, "IMDB_Rating"), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    width: 10,
    height: 10,
    patternUnits: "userSpaceOnUse",
    id: "zr1-p0"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "rgb(0,0,0)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "rgb(0,0,0)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "rgb(0,0,0)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "rgb(0,0,0)",
    fillOpacity: 0.2
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHalfdonutThumb);
export default __webpack_public_path__ + "static/media/halfdonut_thumb.e01cd0ecaa26ce0e9fc647941247a00d.svg";
export { ForwardRef as ReactComponent };